import React from "react";
import { Grid, makeStyles } from "@material-ui/core";
import TimeLineConnector from "../posts/TimeLineConnector";
import AppLinks from "../applinks/AppLinks";

const useStyles = makeStyles((theme) => ({
  root: { flexGrow: 1 },
}));

const MainPage = () => {
  const classes = useStyles();

  return (
    <Grid container className={classes.root}>
      {window.AppInfo.showLinks && (
        <Grid item xs={12} lg={window.AppInfo.showNews ? 7 : 12}>
          <AppLinks />
        </Grid>
      )}
      {window.AppInfo.showNews && (
        <Grid item xs={12} lg={window.AppInfo.showLinks ? 5 : 12}>
          <TimeLineConnector />
        </Grid>
      )}
    </Grid>
  );
};

export default MainPage;
